import { render } from "./InspectionCreate.vue?vue&type=template&id=87ddf694"
import script from "./InspectionCreate.vue?vue&type=script&lang=js"
export * from "./InspectionCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__